import React, { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
import { BookButton } from "@/components/BookButton";

// One last replacement moment. The struck phrase resolves into the full line.
export function Close() {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-100px" });
    const [phase, setPhase] = useState(0); // 0 initial, 1 striking, 2 resolved

    useEffect(() => {
        if (!inView) return;
        // 400ms strike begins (draws 0.45s), holds ~700ms, resolves ~1600ms
        const t1 = setTimeout(() => setPhase(1), 400);
        const t2 = setTimeout(() => setPhase(2), 1600);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        };
    }, [inView]);

    return (
        <section id="close" data-testid="close" className="py-28 sm:py-40">
            <div ref={ref} className="max-w-4xl mx-auto px-5 sm:px-8">
                <h2 className="font-display font-semibold tracking-[-0.025em] text-4xl sm:text-6xl leading-[1.08]">
                    Every week you wait,{" "}
                    <span className="relative inline-block">
                        <span className={phase === 2 ? "text-foreground" : "text-muted-foreground"}>
                            the manual work gets paid
                        </span>
                        <motion.span
                            aria-hidden
                            className="absolute left-0 top-1/2 h-[0.06em] w-full origin-left rounded-full bg-current"
                            initial={{ scaleX: 0, opacity: 0 }}
                            animate={{
                                scaleX: phase >= 1 ? 1 : 0,
                                opacity: phase === 1 ? 1 : 0,
                            }}
                            transition={phase === 1 ? { duration: 0.45, ease: [0.65, 0, 0.35, 1] } : { duration: 0 }}
                            style={{ translateY: "-50%" }}
                        />
                    </span>
                    <motion.span
                        initial={{ opacity: 0 }}
                        animate={{ opacity: phase === 2 ? 1 : 0 }}
                        transition={{ duration: 0.5 }}
                        className="inline"
                    >
                        {" "}instead of you
                    </motion.span>
                    <span className="period">.</span>
                </h2>

                <p className="mt-8 text-lg text-muted-foreground leading-relaxed max-w-2xl">
                    Free 30-minute call, no pitch. Then you decide what's worth handing off.
                </p>

                <div className="mt-10">
                    <BookButton testid="close-book-a-call" />
                </div>
            </div>
        </section>
    );
}
